/**
 * El plazo de pago de un cliente — `OD-0062` E-03 (ACCEPTED 2026-10-25).
 *
 * ```text
 * opciones   Al contado (0), 15, 30, 45 y 60 días, u "Otro" de 0 a 365
 * aviso      a un cliente que CONSTA como empresa, por encima de 60 días: la
 *            Ley 3/2004, art. 4.3, no deja pactar más. Se avisa y NO se impide
 * quién      lo valida la API (0..365, entero); aquí sólo se elige y se avisa
 * ```
 *
 * Lo escrito en «Otro» viaja como texto, tal cual: la API lo convierte y lo
 * rechaza si no es un número entero. La web no convierte números
 * (`tests/adversarial/web-shell.mjs`), así que la comparación con 60 se hace
 * sobre las cifras.
 */

/** Los plazos de la lista, en días. El resto es «Otro». */
export const PLAZOS_DE_PAGO = ["0", "15", "30", "45", "60"] as const;

/** Ley 3/2004, art. 4.3: entre empresas, como mucho 60 días. */
export const PLAZO_MAXIMO_ENTRE_EMPRESAS = "60";

/** La opción del desplegable que corresponde a un plazo: "" sin plazo, "OTRO" si no está en la lista. */
export function opcionDePlazo(plazo: number | string | null): string {
  if (plazo === null || plazo === "") return "";
  const texto = String(plazo);
  return (PLAZOS_DE_PAGO as readonly string[]).includes(texto) ? texto : "OTRO";
}

/** Si `plazo` son cifras que pasan de 60. Lo que no son cifras no avisa: ya lo rechaza la API. */
export function pasaDelMaximoEntreEmpresas(plazo: number | string | null): boolean {
  if (plazo === null) return false;
  const cifras = String(plazo).trim();
  if (!/^[0-9]+$/.test(cifras)) return false;
  const sinCeros = cifras.replace(/^0+(?=[0-9])/, "");
  const maximo = PLAZO_MAXIMO_ENTRE_EMPRESAS;
  return sinCeros.length > maximo.length || (sinCeros.length === maximo.length && sinCeros > maximo);
}
